<script>
	export let src
	export let alt
</script>

<img class="rounded-lg" {src} {alt} />
